if (sessionStorage["ipCountryCode"] == null || sessionStorage["ipCountryCode"] == 'null' || sessionStorage["ipCountryCode"] == "undefined" || sessionStorage["timezone"] == null || sessionStorage["timezone"] == "undefined") {
    fetch("https://ipinfo.io/json?token=12e8178bc24f84")
        .then(function (response) {
            if (response.ok) {
              console.log('OK');
                return response.json();

            } else {
                sessionStorage["ipCountryCode"] = null;
                sessionStorage["timezone"] = null;
            }
        })
        .then(function (data) {
            sessionStorage["ipCountryCode"] = data.country;
            sessionStorage["timezone"] = data.timezone;
        })
}

/*
Token Léa :12e8178bc24f84
Token Antoine : 8521ad5bc8e785
Token Charly :353b8251a2c69a
Token Owen : f2012060130eff
*/
